// extracted by mini-css-extract-plugin
export default {"AdSlotMail__mail":"bgg_a bhf_wj bhf_a bhf_q bhf_k","AdSlotMail__mail--notLoaded":"bgg_b bhf_ey bhf_bj bhf_wy","show-ad-not-loaded":"bgg_c","AdSlotMail__cta":"bgg_e"};